import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { Inbox, FolderOpenDot, Sparkles, Newspaper, MailPlus, MessageSquareQuote } from 'lucide-react';

const cards = [
  { table: 'leads', label: 'Leads', icon: Inbox },
  { table: 'projects', label: 'Projects', icon: FolderOpenDot },
  { table: 'services', label: 'Services', icon: Sparkles },
  { table: 'blog_posts', label: 'Posts', icon: Newspaper },
  { table: 'newsletter', label: 'Subscribers', icon: MailPlus },
  { table: 'testimonials', label: 'Testimonials', icon: MessageSquareQuote },
];

export default function AdminDashboard() {
  const [counts, setCounts] = useState({});
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    (async () => {
      const c = {};
      for (const card of cards) {
        const { count } = await supabase.from(card.table).select('*', { count: 'exact', head: true });
        c[card.table] = count ?? 0;
      }
      setCounts(c);
      const { data } = await supabase.from('leads').select('*').order('created_at', { ascending: false }).limit(5);
      setRecent(data || []);
    })();
  }, []);

  return (
    <div>
      <h1 className="font-display text-3xl text-ink-900">Welcome back.</h1>
      <p className="mt-1 text-sm text-ink-500">Here&apos;s what&apos;s happening in your studio.</p>

      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {cards.map(c => (
          <div key={c.table} className="rounded-3xl border border-ink-100 bg-white p-6">
            <div className="flex items-center justify-between">
              <c.icon className="h-5 w-5 text-cyan" />
              <span className="text-xs uppercase tracking-[0.2em] text-ink-400">{c.label}</span>
            </div>
            <p className="mt-6 font-display text-4xl font-light text-ink-900">{counts[c.table] ?? '—'}</p>
          </div>
        ))}
      </div>

      <div className="mt-10 rounded-3xl border border-ink-100 bg-white p-6">
        <h2 className="font-display text-xl text-ink-900">Latest leads</h2>
        {recent.length === 0 ? <p className="mt-4 text-sm text-ink-500">No leads yet. The contact form will populate this.</p> : (
          <div className="mt-4 divide-y divide-ink-100">
            {recent.map(l => (
              <div key={l.id} className="flex flex-wrap items-center justify-between gap-2 py-3 text-sm">
                <div>
                  <p className="font-medium text-ink-900">{l.name || 'Anonymous'} — <span className="text-ink-500">{l.email}</span></p>
                  <p className="text-xs text-ink-400">{l.company} · {l.service} · {l.budget}</p>
                </div>
                <span className="rounded-full bg-cyan-soft px-3 py-1 text-[11px] font-medium uppercase tracking-widest text-cyan-700">{l.status}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
